import { useState } from 'react';
import { api, PanelHowTo } from './_barrel.js';


        // Known associates — people linked to the subject by data already held
        // (shared directorships + analyst-recorded relationships). Reads
        // /api/v1/subjects/{id}/associates (fetched by the parent).
        function KnownAssociatesPanel({ associates }) {
            const list = associates || [];
            const [open, setOpen] = useState(false);
            return (
                <div className="panel mb-6">
                    <div className="panel-header is-self-collapse flex justify-between items-center cursor-pointer"
                        onClick={() => setOpen(!open)}>
                        <div className="font-display text-xl gold">Known Associates</div>
                        <div className="flex items-center gap-3">
                            <div className="text-xs text-muted font-mono">
                                {list.length ? `${list.length} linked` : 'shared directorships & recorded links'}
                            </div>
                            <div className="text-xs text-muted">{open ? '▾' : '▸'}</div>
                        </div>
                    </div>
                    <PanelHowTo id="associates" />
                    {open && (list.length === 0 ? (
                        <div className="px-6 py-8 text-muted text-sm">
                            No associates linked yet — they surface automatically from shared directorships and any relationships recorded against this subject.
                        </div>
                    ) : (
                        <div className="px-6 py-5 space-y-2">
                            {list.map((p, idx) => (
                                <div key={idx} className="flex justify-between items-start gap-4 py-2 border-b border-veil last:border-b-0">
                                    <div className="flex-1 min-w-0">
                                        <div className="text-sm text-paper">{p.name}</div>
                                        {p.basis && <div className="text-xs text-muted font-mono mt-1">shared: {p.basis}</div>}
                                    </div>
                                    <div className="flex-shrink-0 text-[10px] font-mono uppercase tracking-widest" style={{ color: 'var(--gold)' }}>
                                        {p.relationship}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            );
        }

export { KnownAssociatesPanel };
